export default __webpack_public_path__ + "static/media/ar_down.ccf306cb.svg";